import { defineStore } from 'pinia';
import { watch } from 'vue';

export const useDeviceStore = defineStore('device', {
    state: () => ({
        smallNavBar: false
    }),

    actions: {
        initialize() {
            watch(this, (state) => {
                Object.keys(this.$state).forEach((key) => {
                    console.log(key, state[key]);
                    localStorage.setItem(key, JSON.stringify(state[key]));
                });
            });

            Object.keys(this.$state).forEach((key) => {
                if (localStorage.getItem(key) !== null) {
                    try {
                        this[key] = JSON.parse(localStorage.getItem(key));
                    } catch (error) {
                        console.error(`Error parsing localStorage item "${key}":`, error);
                    }
                }
            });
        }
    }
});
